module.exports = __webpack_public_path__ + "static/media/5mm.06482068.png";